import { ReliefSVG } from '@pm2/ui-components';
import { wrapper, svg } from './atom.frontpage-graphic.style.js';
import { jsx } from 'react/jsx-runtime';

function FrontpageGraphic() {
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    children: /*#__PURE__*/jsx(ReliefSVG, {
      className: svg,
      position: "top"
    })
  });
}

export { FrontpageGraphic };
//# sourceMappingURL=atom.frontpage-graphic.js.map
